
export async function loadSignalRService() {
  const module = await import('./SignalRService');
  return module.SignalRService;
}
